export const emptyCurriculumForm = {
  id: '',
  name: '',
  academic_year_id: '',
  sort_order: '1',
  is_published: false,
  topic_ids: [],
};

export const emptyTopicForm = {
  id: '',
  curriculum_id: '',
  curriculum_ids: [],
  curriculum_topics: [],
  name: '',
  description: '',
  sort_order: '1',
  is_published: false,
  created_at: '',
  image_media: [],
  video_media: [],
  media_dirty: false,
};

export const emptyModuleForm = {
  id: '',
  topic_id: '',
  name: '',
  description: '',
  sort_order: '1',
  is_published: false,
  curriculum_units: [],
  created_at: '',
  image_media: [],
  video_media: [],
  media_dirty: false,
};

export const emptyExerciseForm = {
  id: '',
  module_id: '',
  name: '',
  description: '',
  sort_order: '1',
  is_published: false,
  created_at: '',
  image_media: [],
  video_media: [],
  media_dirty: false,
  answers: [
    { id: '', text: '', correct: true, sort_order: '1' },
    { id: '', text: '', correct: false, sort_order: '2' },
  ],
};

export const emptyExamForm = {
  id: '',
  curriculum_id: '',
  title: '',
  description: '',
  is_published: false,
  is_archived: false,
  availability_scheduled: false,
  available_from: '',
  duration_minutes: '30',
  pass_score_threshold: '70',
  exercise_ids: [],
  questions: [
    {
      id: '',
      topic_id: '',
      module_id: '',
      prompt: '',
      description: '',
      resource_url: '',
      image_media: [],
      sort_order: '1',
      answers: [
        {
          id: '',
          text: '',
          correct: true,
          sort_order: '1',
          feedback_text: '',
          image_media: [],
          video_media: [],
        },
        {
          id: '',
          text: '',
          correct: false,
          sort_order: '2',
          feedback_text: '',
          image_media: [],
          video_media: [],
        },
      ],
    },
  ],
  created_at: '',
  image_media: [],
  video_media: [],
  media_dirty: false,
};

export const emptyQuestionForm = {
  id: '',
  topic_id: '',
  module_id: '',
  curriculum_units: [],
  prompt: '',
  description: '',
  reasoning_process: '',
  resource_url: '',
  is_active: true,
  image_media: [],
  media_dirty: false,
  answers: [
    { id: '', text: '', correct: true, sort_order: '1', feedback_text: '' },
    { id: '', text: '', correct: false, sort_order: '2', feedback_text: '' },
  ],
};

export const emptyInlineExerciseForm = {
  module_id: '',
  name: '',
  description: '',
  sort_order: '1',
  is_published: false,
  answers: [
    { id: '', text: '', correct: true, sort_order: '1' },
    { id: '', text: '', correct: false, sort_order: '2' },
  ],
};

export const DEFAULT_USER_ORGANIZATION = 'MentoringMaths';

export const emptyUserForm = {
  id: '',
  student_id: '',
  display_name: '',
  first_name: '',
  last_name: '',
  username: '',
  email: '',
  organization_id: '',
  organization: DEFAULT_USER_ORGANIZATION,
  curriculum_id: '',
  curriculum_ids: [],
  academic_level: '',
  role_id: '',
  is_active: true,
  password: '',
  password_confirm: '',
};

export const emptyRoleForm = {
  id: '',
  name: '',
  privileges_text: '',
};
